import { FC, useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";

import styles from "./styles.module.scss";

interface IProps {
    onClose(): void;
}

const Collaborators: FC<IProps> = ({ onClose }) => {
    const collaboratorsRef = useRef(null);
    const [isMounted, setIsMounted] = useState(true);

    const handleDocumentClick = useCallback(
        (e: Event) => {
            if (
                isMounted &&
                collaboratorsRef.current &&
                !ReactDOM.findDOMNode(collaboratorsRef.current)?.contains(e.target as Node)
            )
                onClose();
        },
        [onClose, collaboratorsRef, isMounted],
    );

    useEffect(() => {
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("touchend", handleDocumentClick);

        return () => {
            document.removeEventListener("click", handleDocumentClick);
            document.removeEventListener("touchend", handleDocumentClick);
        };
    }, [handleDocumentClick]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <div className={styles.Collaborators} ref={collaboratorsRef}>
            <Header />

            <Content />

            <Footer />
        </div>
    );
};

export default Collaborators;
